import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=5d1f0530&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=5d1f0530&prod&lang=less"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=5d1f0530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f0530",
  null
  
)

export default component.exports